import { Link } from 'react-router-dom';

/**
 * Placeholder Terms of Service copy -- pending legal sign-off. Exists so the Footer's
 * "Terms of Service" link (and the Register page's consent checkbox) resolve to a real page
 * instead of the 404 catch-all. Replace the body copy once legal provides final text; bump
 * CURRENT_TERMS_VERSION in the backend (auth-service/src/config/constants.ts) whenever the terms
 * materially change, so newly-recorded consent reflects the version the user actually saw.
 */
export default function TermsPage() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-16">
      <Link to="/" className="text-sm text-primary-500 hover:text-primary-600">&larr; Back to BookBed</Link>
      <h1 className="mt-6 text-3xl font-bold text-gray-900">Terms of Service</h1>
      <p className="mt-2 rounded-lg bg-amber-50 border border-amber-200 px-4 py-3 text-sm text-amber-800">
        Placeholder — pending legal review. This page does not yet contain final, legally-reviewed terms.
      </p>
      <div className="mt-8 space-y-6 text-sm leading-6 text-gray-700">
        <section>
          <h2 className="text-lg font-semibold text-gray-900">1. Acceptance of terms</h2>
          <p className="mt-2">By creating a BookBed account, you agree to be bound by these Terms of Service and our Privacy Policy.</p>
        </section>
        <section>
          <h2 className="text-lg font-semibold text-gray-900">2. Using BookBed</h2>
          <p className="mt-2">You agree to use BookBed only for lawful purposes and in accordance with these terms.</p>
        </section>
        <section>
          <h2 className="text-lg font-semibold text-gray-900">3. Bookings and hosting</h2>
          <p className="mt-2">Guests and hosts are each responsible for the accuracy of the information they provide when booking or listing a property.</p>
        </section>
        <section>
          <h2 className="text-lg font-semibold text-gray-900">4. Changes to these terms</h2>
          <p className="mt-2">We may update these terms from time to time. Continued use of BookBed after a change constitutes acceptance of the revised terms.</p>
        </section>
      </div>
    </div>
  );
}
